module.exports = __webpack_public_path__ + "8f833545cb05bab0b85c0caeafc6076c.png";